import { combineReducers } from "redux";
import authReducer from "./slices/authSlice";
import instancesReducer from "./slices/instancesSlice";
import tableReducer from "./slices/tableSlice";
import notificationReducer from "./slices/notificationSlice";
import instanceHistoryReducer from "./slices/instanceHistorySlice";
import tenantsReducer from "./slices/tenantsSlice";
import dashboardReducer from "./slices/dashboardSlice";
import userPreferencesReducer from "./slices/userPreferencesSlice";
import uiReducer from "./slices/uiSlice";
import reportTabsReducer from "./slices/reportTabsSlice";
import { employeePresenceReducer } from "./slices/employeePresenceSlice";
import { baseApi } from "./api/baseApi";
import { publicApi } from "./api/publicApi";

const rootReducer = combineReducers({
  authReducer,
  instanceHistoryReducer,
  instancesReducer,
  tableReducer,
  notificationReducer,
  tenantsReducer,
  dashboardReducer,
  userPreferencesReducer,
  uiReducer,
  reportTabsReducer,
  // Typing and presence. Never persisted: both are true only while the socket
  // that reported them is open.
  employeePresenceReducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [publicApi.reducerPath]: publicApi.reducer,
});

export default rootReducer;
